import React, {useEffect, useState} from "react";
import {fetchRequestMyRequests} from "../../api/crm/feedback";
import siteStructure from "../siteStructure.json";
import {getImagesStructure} from "../utils/siteStructure";
import {useTheme} from "../header/Header";

// Картинки теперь в public → строковые URL.
const supportImage = "/images/crm/support.webp";

export function convertDateToPoint(date) {
    let day = date.slice(8)
    let month = date.slice(5, 7)
    let year = date.slice(0, 4)

    return `${day}.${month}.${year}`
}

export default function MyRequests() {

    const [title, setTitle] = useState("Мои заявки")
    const [requestList, setRequestList] = useState([])
    const {theme} = useTheme()

    useEffect( () => {

        async function getRequsetsList() {

            const token = localStorage.getItem('token');
            try {
                const data = await fetchRequestMyRequests(token)

                if(Object.keys(data).includes("error")){
                    setTitle(data.error)
                    return
                }

                setRequestList(data)
            } catch (error) {
                setTitle("Нет заявок")
                console.log(error)
            }
        }

        getRequsetsList()

    }, [])

    return (
        <div className={"myRequests"}>
            <div className={`complexBack ${theme}`}> </div>

            <h1 className={`${theme === "dark"? null : "lightTitle"}`}>{title}</h1>
            <RequestList requestList={requestList}/>
        </div>
    )
}

const LoadingDots = () => {
    return (
        <div className="myRequestsWaiting">
            <span className="dot">.</span>
            <span className="dot">.</span>
            <span className="dot">.</span>
        </div>
    )
}

function compareDate(date_start, date_end) {

    return convertDateToPoint(date_start.slice(0, 10)) === convertDateToPoint(date_end.slice(0, 10))

}

function RequestList({requestList}) {

    const imagesConst = getImagesStructure(siteStructure)
    const {theme} = useTheme()

    function handleStatus(status){
        switch (status) {
            case "Заявка":
                return {text:"Ожидает ответа", color: "#dd6326"}
            case "В работе":
                return {text:"В работе", color: "#01a1ff"}
            case "Закрыта":
                return {text:"Закрыта", color: "#11c44c"}
            case "Отменена":
                return {text:"Отменена", color: "#b31919"}
            default:
                return {text:"Ошибка", color: "#b31919"}
        }
    }

    // Все картинки теперь в public → просто строим URL.
    // Если в siteStructure нет нужного пути — отдаём noImg.webp.
    const getImage = (path) => {
        if (imagesConst[path]) {
            return `/images/${imagesConst[path]}`;
        }
        return `/images/noImg.webp`;
    }

    return (
        <div className={"myRequestList"}>
            {requestList.map((e, index) => {
                const uniqueKey = e.time_begin || `item-${index}`;

                return (
                    <div className={`myRequestItem ${theme}`} key={uniqueKey}>
                        <div className={e.object !== "request"? "myRequestProduct" : "myRequestSupport"}>
                            {e.object === "request"?
                                <img src={supportImage} alt="no-img"/> :
                                <>
                                    <img src={getImage(e.object)} alt="no-img"/>
                                    <p>{e.object}</p>
                                </>
                            }
                        </div>
                        <div className={`myRequestsBlock ${theme}`}>
                            <div>
                                <h4>{convertDateToPoint(e.time_begin.slice(0,10))}</h4>
                                <div className={"myRequestsStatus"} style={{background: handleStatus(e.status).color}}>
                                    {handleStatus(e.status).text}
                                </div>
                                <div className={"myRequestsUserQuestionWrapper"}>
                                    <span>Ваш вопрос</span>
                                    <p>{e.text}</p>
                                    <span>{e.time_begin.slice(11,19)}</span>
                                </div>

                                {e.status === "Заявка"? <LoadingDots /> : <WorkTime data={e} timeType={"time_work"} text={"Принят в работу"}/>}

                                {e.status === "В работе"?  <LoadingDots /> : null}

                                {e.commentFromManager === ""? null :
                                    <div className={"myRequestsManagerAnswerWrapper"}>
                                        <div className={"myRequestsUserQuestionWrapper"}>
                                            <span>Менеджер</span>
                                            <p>{e.commentFromManager}</p>
                                            <span>{e.time_close.slice(11,19)}</span>
                                        </div>

                                        {(e.status === "Закрыта" || e.status === "Отменена") && !compareDate(e.time_begin, e.time_close)?
                                            <h4 className={"myRequestsWorkTime"}>{`Дата ответа ${convertDateToPoint(e.time_close.slice(0,10))}`}</h4>
                                            : null
                                        }
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                )
            })}
        </div>
    )
}

function WorkTime({data, timeType, text}) {

    const time = data[timeType].slice(11,19)
    const date = compareDate(data.time_begin, data[timeType])? "" : convertDateToPoint(data[timeType].slice(0,10))

    return (
        <h4 className={"myRequestsWorkTime"}>{`${text} ${date} ${time}`}</h4>
    )

}